import type { FC, ReactNode } from 'react'

import { BadgeCheck } from 'lucide-react'
import { Bubble } from '@/components/generals/bubble'
import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { PROMISE, REASONS } from '@/constants/content'

export const WhySection: FC = (): ReactNode => {
    return (
        <section id='why-us' aria-labelledby='why-us-title' className='relative scroll-mt-20 overflow-hidden bg-ink py-20 text-white sm:py-28'>
            <div aria-hidden='true' className='pointer-events-none absolute -left-40 top-10 size-[28rem] rounded-full bg-aqua/10 blur-3xl' />
            <div aria-hidden='true' className='pointer-events-none absolute -right-32 bottom-0 size-[22rem] rounded-full bg-aqua-deep/20 blur-3xl' />

            <Bubble className='right-[8%] top-16 size-16 opacity-60' />
            <Bubble className='bottom-20 left-[45%] hidden size-10 opacity-50 [animation-delay:-4s] lg:block' />

            <Container className='relative grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16'>
                <div className='flex flex-col'>
                    <SectionHeading
                        id='why-us-title'
                        eyebrow='Why drivers choose us'
                        title="We treat every car like it's our own"
                        description='Good results come from good habits. These are the ones we never skip, whether it is a quick wash or a full detail.'
                        inverted
                    />

                    <div className='mt-10 rounded-[1.75rem] bg-aqua p-6 text-ink sm:p-7 lg:mt-auto'>
                        <div className='flex items-center gap-3'>
                            <BadgeCheck className='size-7 shrink-0' />

                            <h3 className='font-heading text-2xl font-bold uppercase tracking-wide'>
                                {PROMISE.title}
                            </h3>
                        </div>

                        <p className='mt-3 leading-relaxed text-ink/80'>
                            {PROMISE.body}
                        </p>
                    </div>
                </div>

                <ul className='grid gap-5 sm:grid-cols-2'>
                    {REASONS.map(reason => (
                        <li key={reason.title} className='rounded-[1.75rem] bg-ink-soft p-7 ring-1 ring-ink-line'>
                            <span className='grid size-12 place-items-center rounded-2xl bg-aqua/15 text-aqua'>
                                <reason.icon className='size-6' />
                            </span>

                            <h3 className='mt-6 font-heading text-2xl font-bold uppercase tracking-wide'>
                                {reason.title}
                            </h3>

                            <p className='mt-2 leading-relaxed text-white/70'>
                                {reason.body}
                            </p>
                        </li>
                    ))}
                </ul>
            </Container>
        </section>
    )
}
